import React from "react";
import Style from '../Styles/Common.module.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CommitimemberComponent from "./Commitimember";
import { Link } from "react-router-dom";
import { IoArrowForwardCircleOutline } from "react-icons/io5";

const InfrastructureComponent = ()=>{
    return(
    <div className={Style.infrastructursec+"  "+Style.clear}>
           <Container>
                <Row>
                    <Col>
                        <div className={Style.center}>
                            <h2 className={Style.abouttitle}>OFFICE BEARERS &amp; COMMITTEE MEMBERS</h2>
                        </div>
                    </Col>
</Row>
<Row>
                    <Col lg={3} className={Style.memberWidth}>
                        <div className={Style.infrastructurbox +" "+Style.AlignCenter}>
                            <div className={Style.img}>
                                <img alt="" src={require('../../assest/images/president.png')}/></div>

                            <h3>Mr. Harmeet Singh</h3>
                            <p>President</p>
                        </div>
                    </Col>
                    <Col lg={3} className={Style.memberWidth}>
                    <div className={Style.infrastructurbox +" "+Style.AlignCenter}>
                            <div className={Style.img}>
                                 <img alt="" src={require('../../assest/images/vicepresident.jpg')}/>
                                </div>
                            <h3>Mr. Sumant Dhamija </h3>
                            <p>Vice President</p>
                        </div>
                    </Col>
                  <Col lg={3} className={Style.memberWidth}>
                  <div className={Style.infrastructurbox +" "+Style.AlignCenter}>
                            <div className={Style.img}>
                              
                                <img alt="" src={require('../../assest/images/secretary-j.png')}/>
                                </div>

                            <h3>Mr. Kirit Javali </h3>
                            <p>Secretary</p>
                        </div>
                    </Col>

                    <Col lg={3} className={Style.memberWidth}>
                  <div className={Style.infrastructurbox +" "+Style.AlignCenter}>
                            <div className={Style.img}>
                            <img alt="" src={require('../../assest/images/treasurer.png')}/>
                              
                              </div>

                            <h3>Mr. Pankaj Karna</h3>
                            <p>Treasurer</p>
                            </div>
                    </Col>
                </Row>
            </Container>
            <CommitimemberComponent />
        </div>
    )
}

export default InfrastructureComponent;